import '@beat-venues/ui/styles/react';
import '../src/utils/i18n';

import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { AnalyticsProvider, UserProvider } from './context';
import { router } from './utils';

const environments = () => {
    const url = window.location.href;

    let env = 'production';
    if (url.includes('.tst')) {
        env = 'testing';
    }
    if (url.includes('.acc')) {
        env = 'acceptance';
    }
    if (url.includes('localhost')) {
        env = 'local';
    }
    return env;
};

Sentry.init({
    dsn: 'https://1a82f280c958754fced0787656107572@o164212.ingest.us.sentry.io/4509269682946048',
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/mybeat\.beatvenues\.be(\/.*)?$/],
    environment: environments(),
});

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <StrictMode>
        <QueryClientProvider client={new QueryClient()}>
            <UserProvider>
                <AnalyticsProvider>
                    <RouterProvider router={router} />
                </AnalyticsProvider>
            </UserProvider>
        </QueryClientProvider>
    </StrictMode>
);
